import { useContext, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Unity, useUnityContext } from "react-unity-webgl";
import { dispatchSubheaderTextUpdate } from '../../../functions/functions';
import { StateContext, DispatchContext} from '../../../App';
import Subheader from '../../3_SubHeader/Subheader';
import Loader from '../../Loader/Loader';

import './UnityCanvas.css'

const OvalButton = () => {
    const dispatch = useContext(DispatchContext);
    const appState = useContext(StateContext);

    const { isSummaryOpen } = appState.appSettings;
    const handleClick = () => {
        // console.log(JSON.stringify(appState.selections))
        dispatch({
            type: 'TOGGLE_SIDEMENU',
            payload: true
        })
        dispatch({
            type: 'TOGGLE_SUMMARY_OPEN',
            payload: !isSummaryOpen
        })
    }
    return (
        <button 
            className={isSummaryOpen ? 'summary-btn summary-active' : 'summary-btn'}
            onClick={() => handleClick()}
        >
            <FormattedMessage
                id='summary'
                defaultMessage='Summary'
            />
        </button>
    )
};

const UnityCanvas = ({canvasHeight}) => {
    const appState = useContext(StateContext);
    const dispatch = useContext(DispatchContext);

    const { subheaderText } = appState.appSettings;
    const { materials, fabrics, articles } = appState.selections;

    const [ subheaderTextInput, setSubHeaderTextInput ] = useState({...subheaderText, info: null, title: subheaderText.title, note: ''});
    const [ firstLoad, setFirstLoad ] = useState(true);

    const { unityProvider, sendMessage, isLoaded } = useUnityContext({
        loaderUrl: '/Build/WebGL.loader.js',
        dataUrl: '/Build/WebGL.data',
        frameworkUrl: '/Build/WebGL.framework.js',
        codeUrl: '/Build/WebGL.wasm'
    });

    useEffect(() => {
        if (firstLoad) {
            let textInput = {...subheaderText, info: '', title: subheaderText.title, note: ''};
            dispatchSubheaderTextUpdate(dispatch, textInput);
            setSubHeaderTextInput(textInput);
            setFirstLoad(false);
        } else {
            setSubHeaderTextInput(subheaderText);
        }
    }, [subheaderText, firstLoad]);


    // useEffect(() => {
    //     addEventListener('OnMounted', console.log('isMounted'));
    //     return () => {
    //         removeEventListener('OnMounted')
    //     }
    // })

    // useEffect(() => {
        
    //     if (isLoaded && materials !== undefined) {
    //         console.log('send message MATERIALS', materials);
    //         sendMessage('ReactToUnity', 'SetConfiguration', JSON.stringify({selections: appState.selections}));
    //     };
    // }, [materials, isLoaded, sendMessage]);

    // useEffect(() => {
    //     if (isLoaded && fabrics !== undefined) {
    //         console.log('send message FABRICS', fabrics);
    //         sendMessage('ReactToUnity', 'SetConfiguration', JSON.stringify({selections: appState.selections}));
    //     };
    // }, [fabrics, isLoaded, sendMessage]);

    useEffect(() => {
        // console.log('UNITY', articles)
        if (isLoaded && articles !== undefined) {
            // console.log('send message CONFIG', articles);
            sendMessage('ReactToUnity', 'SetConfiguration', JSON.stringify({selections: appState.selections}));
        };
    }, [articles, materials, fabrics, isLoaded, sendMessage]);

    return (
        <div className='unityCanvas' >
            <Subheader 
                subheaderTextInput={subheaderTextInput}
                textPos={'left'}
            />
            <Loader
                height={canvasHeight}
                isLoaded={isLoaded}
            />
            <Unity 
                className='unity' 
                id='unity' 
                unityProvider={unityProvider} 
                style={{
                    position: 'relative', 
                    width: '100%', 
                    height: `${canvasHeight}px`, 
                    visibility: isLoaded ? "visible" : "hidden" 
                }} 
            />  
            <OvalButton />
            {/* <button onClick={() => handleClick()} style={{zIndex: '9999', position: 'absolute', top: '200px'}}>click</button>  */}
        </div>
    )
};
export default UnityCanvas;